export default __webpack_public_path__ + "media/Number11.72fe074c44849e6199eaa6a912cca47a.mp4";